import { c as _c } from "react/compiler-runtime";
import { FieldController } from '@module/mdrt-org/shared/components/field-controller/field-controller';
import { SelectField } from '@module/mdrt-org/shared/components/select-field/select-field';
import { MAX_ADDRESS_LINE_LENGTH, MAX_CITY_LENGTH, MAX_ZIP_CODE_LENGTH } from '@module/mdrt-org/shared/utils/constants/inputs-constants';
import { LATIN_ONLY_ADDRESS_REGEXP } from '@module/mdrt-org/shared/utils/types/regexp';
import { FormInput } from '@shared/ui-components/form-input/form-input';
import { type SelectOption } from '@shared/utils/types/select-option';
import { useAccountSettingsPageContext } from '../../providers/account-settings-page-context';
import { type ContactInformationFormData } from '../../utils/types/form-data';
import { type AccountSettingsContactInformationContent } from './get-account-settings-contact-information-content';
import styles from './contact-information-form.module.scss';
const PARENT_CLASSNAME = 'contact-information-form';
export const MailingAddressSection = t0 => {
  const $ = _c(71);
  const {
    cmsContent,
    countryOptions,
    stateOptions
  } = t0;
  const {
    countriesData,
    customerProfileContextData
  } = useAccountSettingsPageContext();
  let t1;
  if ($[0] !== countriesData || $[1] !== customerProfileContextData) {
    let t2;
    if ($[3] !== customerProfileContextData) {
      t2 = country => country.countryId === customerProfileContextData.countryId;
      $[3] = customerProfileContextData;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = countriesData.find(t2);
    $[0] = countriesData;
    $[1] = customerProfileContextData;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selectedMailingAddressCountry = t1;
  let t2;
  if ($[5] !== cmsContent.mailingAddressTitleLabel) {
    t2 = <h2 className={styles[`${PARENT_CLASSNAME}__heading`]}>{cmsContent.mailingAddressTitleLabel}</h2>;
    $[5] = cmsContent.mailingAddressTitleLabel;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== cmsContent.countryHint || $[8] !== cmsContent.countryLabel || $[9] !== countryOptions) {
    t3 = <SelectField hint={cmsContent.countryHint} isClearable={true} isDisabled={true} isSearchable={true} label={cmsContent.countryLabel} name="countryId" options={countryOptions} />;
    $[7] = cmsContent.countryHint;
    $[8] = cmsContent.countryLabel;
    $[9] = countryOptions;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = `${cmsContent.latinOnlyMessage}`;
  let t5;
  if ($[11] !== t4) {
    t5 = {
      message: t4,
      value: LATIN_ONLY_ADDRESS_REGEXP
    };
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = `${cmsContent.requiredLabel}`;
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = {
      pattern: t5,
      required: t6
    };
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FormInput maxLength={MAX_ADDRESS_LINE_LENGTH} />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== cmsContent.addressLine1Label || $[18] !== t7) {
    t9 = <FieldController label={cmsContent.addressLine1Label} name="addressLineOne" rules={t7}>{t8}</FieldController>;
    $[17] = cmsContent.addressLine1Label;
    $[18] = t7;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = `${cmsContent.latinOnlyMessage}`;
  let t11;
  if ($[20] !== t10) {
    t11 = {
      pattern: {
        message: t10,
        value: LATIN_ONLY_ADDRESS_REGEXP
      }
    };
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <FormInput maxLength={MAX_ADDRESS_LINE_LENGTH} />;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== cmsContent.addressLine2Label || $[24] !== t11) {
    t13 = <FieldController label={cmsContent.addressLine2Label} name="addressLineTwo" rules={t11}>{t12}</FieldController>;
    $[23] = cmsContent.addressLine2Label;
    $[24] = t11;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = `${cmsContent.latinOnlyMessage}`;
  let t15;
  if ($[26] !== t14) {
    t15 = {
      pattern: {
        message: t14,
        value: LATIN_ONLY_ADDRESS_REGEXP
      }
    };
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <FormInput maxLength={MAX_ADDRESS_LINE_LENGTH} />;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== cmsContent.addressLine3Label || $[30] !== t15) {
    t17 = <FieldController label={cmsContent.addressLine3Label} name="addressLineThree" rules={t15}>{t16}</FieldController>;
    $[29] = cmsContent.addressLine3Label;
    $[30] = t15;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const t18 = `${cmsContent.latinOnlyMessage}`;
  let t19;
  if ($[32] !== t18) {
    t19 = {
      message: t18,
      value: LATIN_ONLY_ADDRESS_REGEXP
    };
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== cmsContent.requiredLabel || $[35] !== t19) {
    t20 = {
      pattern: t19,
      required: cmsContent.requiredLabel
    };
    $[34] = cmsContent.requiredLabel;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <FormInput maxLength={MAX_CITY_LENGTH} />;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== cmsContent.cityLabel || $[39] !== t20) {
    t22 = <FieldController label={cmsContent.cityLabel} name="addressCityOrTown" rules={t20}>{t21}</FieldController>;
    $[38] = cmsContent.cityLabel;
    $[39] = t20;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  const t23 = selectedMailingAddressCountry?.stateProvinceIsRequired;
  let t24;
  if ($[41] !== cmsContent.requiredLabel || $[42] !== selectedMailingAddressCountry?.stateProvinceIsRequired) {
    t24 = {
      validate: {
        required: value => !value && selectedMailingAddressCountry?.stateProvinceIsRequired ? cmsContent.requiredLabel : true
      }
    };
    $[41] = cmsContent.requiredLabel;
    $[42] = selectedMailingAddressCountry?.stateProvinceIsRequired;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== cmsContent.stateProvinceLabel || $[45] !== stateOptions || $[46] !== t23 || $[47] !== t24) {
    t25 = <SelectField isClearable={true} isRequired={t23} isSearchable={true} label={cmsContent.stateProvinceLabel} name="addressStateOrProvinceId" options={stateOptions} rules={t24} />;
    $[44] = cmsContent.stateProvinceLabel;
    $[45] = stateOptions;
    $[46] = t23;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  const t26 = selectedMailingAddressCountry?.postalCodeIsRequired;
  let t27;
  if ($[49] !== cmsContent.latinOnlyMessage) {
    t27 = {
      message: cmsContent.latinOnlyMessage,
      value: LATIN_ONLY_ADDRESS_REGEXP
    };
    $[49] = cmsContent.latinOnlyMessage;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] !== cmsContent.requiredLabel || $[52] !== selectedMailingAddressCountry?.postalCodeIsRequired) {
    t28 = {
      required: value_0 => !value_0 && selectedMailingAddressCountry?.postalCodeIsRequired ? cmsContent.requiredLabel : true
    };
    $[51] = cmsContent.requiredLabel;
    $[52] = selectedMailingAddressCountry?.postalCodeIsRequired;
    $[53] = t28;
  } else {
    t28 = $[53];
  }
  let t29;
  if ($[54] !== t27 || $[55] !== t28) {
    t29 = {
      pattern: t27,
      validate: t28
    };
    $[54] = t27;
    $[55] = t28;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  let t30;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <FormInput maxLength={MAX_ZIP_CODE_LENGTH} />;
    $[57] = t30;
  } else {
    t30 = $[57];
  }
  let t31;
  if ($[58] !== cmsContent.postalCodeLabel || $[59] !== t26 || $[60] !== t29) {
    t31 = <FieldController isRequired={t26} label={cmsContent.postalCodeLabel} name="addressZipCode" rules={t29}>{t30}</FieldController>;
    $[58] = cmsContent.postalCodeLabel;
    $[59] = t26;
    $[60] = t29;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== t13 || $[63] !== t17 || $[64] !== t2 || $[65] !== t22 || $[66] !== t25 || $[67] !== t3 || $[68] !== t31 || $[69] !== t9) {
    t32 = <>{t2}{t3}{t9}{t13}{t17}{t22}{t25}{t31}</>;
    $[62] = t13;
    $[63] = t17;
    $[64] = t2;
    $[65] = t22;
    $[66] = t25;
    $[67] = t3;
    $[68] = t31;
    $[69] = t9;
    $[70] = t32;
  } else {
    t32 = $[70];
  }
  return t32;
};